import { useAuthStore } from "@/store/auth/auth.store";
import AuthQuote from "@/components/auth/auth.quote";
import AuthLogo from "@/components/auth/auth.logo";
import SalesRepForm from "./sales.rep.form";
import { Navigate, useSearchParams } from "react-router-dom";
import Error404 from "@/components/404";
import { useEffect, useState } from "react";
import { CodeDetails, getSignUpCodeDeails } from "@/services/auth.service";
import Loader from "@/components/Loader";
import { PATH_HOME } from "@/routes/paths";

const AcceptInviteContainer = () => {
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code") || "";
  const [details, setDetails] = useState<CodeDetails>();
  const { initialized, isLoggedIn } = useAuthStore();

  const fetchData = async () => {
    if (!code || isLoggedIn) return;
    try {
      setLoading(true);
      const response = await getSignUpCodeDeails(code);
      setDetails(response);
    } catch {
      // Error handling is done silently
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    useAuthStore.getState().initializeApp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoggedIn) return <Navigate to={PATH_HOME} />;
  if (!initialized || loading) return <Loader />;
  if ((!code && !details) || (!loading && !details)) return <Error404 />;
  return (
    <div className="grid lg:grid-cols-2 min-h-screen">
      <div className="w-full h-full bg-gray-200 p-6 lg:p-20">
        <div className="mx-auto max-w-sm">
          <AuthLogo />
          <h3 className="text-black font-bold text-center text-dark text-xl md:text-2xl">{`Join ${details?.companyName} today`}</h3>
          <div className="text-black text-center text-sm mb-5 px-10">
            {` You're one step away joining ${details?.companyName} as a Sales Rep`}
          </div>
          <SalesRepForm code={code} details={details} />
        </div>
      </div>

      <AuthQuote />
    </div>
  );
};

export default AcceptInviteContainer;
